module.exports = __webpack_public_path__ + "static/turtle-creek-house35-6d85df73f38260924258068460b06b72.jpg";